import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SidebarService {

  // Observable encargado de visualización de sidebar
  _stateSidebarResource = new BehaviorSubject<Boolean>(null);
  observableStateSidebar$ = this._stateSidebarResource.asObservable();

  // Observable cambio ruta
  _stateRoute = new BehaviorSubject<string>(null);
  observableRoute$ = this._stateRoute.asObservable();

  // Observable encargado de transmitir cantidad de inmuebles
  _countPropertiesResource = new BehaviorSubject<number>(null);
  observableCountPropertiesSidebar$ = this._countPropertiesResource.asObservable();

  // actualizamos valor, este valor se actualizará en todos los oyentes
  changeStateSidebar() {
    this._stateSidebarResource.next(true);
  }

  // actualizamos valor, de ruta
  changeRoute(route: string) {
    this._stateRoute.next(route);
  }

  // actualizamos cantidad de propiedades
  changeCountProperties(propertiesCount: number) {
    this._countPropertiesResource.next(propertiesCount);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/sidebar.service.ts